module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Halal Correct Poland","short_name":"Halal Correct Poland","start_url":"/","description":"Halal Correct Poland provides certification of manufacturers and suppliers of halal products. With our experience of many years, Halal Correct Poland has a reputation for being a unique, professional,and expert organization in Poland and Europe.","background_color":"#663399","display":"minimal-ui","icon":"src/images/logo2.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"0a0acc1f1e180594c2732f9270eea9ef"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
